import { Phone } from "lucide-react";
import { Crest } from "@/components/Crest";
import { AbhiLogo } from "@/components/AbhiLogo";
import { PHONE_TEL, PHONE_DISPLAY, ADDRESS } from "@/data/content";

export default function Footer() {
  return (
    <footer className="border-t border-gold/20 bg-maroon px-4 py-12 sm:px-8">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-8 text-center lg:flex-row lg:justify-between lg:text-left">
        <div className="flex items-center gap-4">
          <Crest className="h-14 w-14" />
          <div>
            <p className="font-display text-xl font-semibold tracking-wide text-amber-50">
              HOTEL ANIL PALACE
            </p>
            <p className="font-kannada text-xs text-gold-light">ಅನಿಲ್ ಪ್ಯಾಲೇಸ್ · ಹೆಮ್ಮಾಡಿ</p>
          </div>
        </div>

        <p className="max-w-md text-xs leading-relaxed text-amber-100/70">
          {ADDRESS} · Near Kollur Mookambika Temple, Maranakatte Temple & Maravante Beach
        </p>

        <div className="text-center lg:text-right">
          <a
            href={PHONE_TEL}
            data-testid="footer-phone-link"
            className="inline-flex items-center gap-2 font-sans text-base font-semibold tabular-nums tracking-wide text-gold-light transition-colors hover:text-gold"
          >
            <Phone className="h-4 w-4" />
            {PHONE_DISPLAY}
          </a>
          <p className="mt-1 text-[11px] uppercase tracking-[0.25em] text-amber-100/50">
            © 2026 Anil Palace · All rights reserved
          </p>
        </div>
      </div>

      <div className="mx-auto mt-10 flex max-w-7xl flex-col items-center justify-center gap-3 border-t border-gold/15 pt-6 sm:flex-row sm:gap-4">
        <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-amber-100/60">
          Managed by
        </span>
        <a
          href="https://abhihospitality.com"
          target="_blank"
          rel="noreferrer"
          data-testid="footer-managed-by-link"
          aria-label="Abhi Hospitality — opens in a new tab"
          className="inline-flex items-center text-amber-50/90 transition-[color,transform] duration-300 hover:scale-[1.04] hover:text-gold-light"
        >
          <AbhiLogo className="h-5 w-auto" />
        </a>
      </div>
    </footer>
  );
}
